import React, { useState, useEffect } from 'react';
import { db } from '../LoginComp/firebase';
import { collection, query, where, getDocs, orderBy, limit, startAfter, getCountFromServer } from 'firebase/firestore';
import './journal.css';



function Binocular_vision() {
 

 const [binocularVision, setBinocularVision] = useState([]);
 const [currentPage, setCurrentPage] = useState(1);
 const [totalPages, setTotalPages] = useState(1);
 const [lastVisible, setLastVisible] = useState(null);

 // Fetch Journal Articles from Firestore -
 const fetchBinocularVision = async (page) => {
   try {
     const pageSize = 6; // Number of items per page
     const binocularVisionRef = collection(db, 'mainresources');
     let q = query(
        binocularVisionRef,
       where('resourceType', '==', 'J U Seekubadu - Binocular Vision'),
       orderBy('created_at'),
       limit(pageSize)
     );

     if (page > 1 && lastVisible) {
       q = query(
        binocularVisionRef,
         where('resourceType', '==', 'J U Seekubadu - Binocular Vision'),
         orderBy('created_at'),
         startAfter(lastVisible),
         limit(pageSize)
       );
     }

     const querySnapshot = await getDocs(q);
     const BinocularVisionarticles = querySnapshot.docs.map(doc => ({
       id: doc.id,
       ...doc.data()
     }));

     setBinocularVision(BinocularVisionarticles);
     setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);

     // Calculate total pages using count query
     const countSnapshot = await getCountFromServer(query(binocularVisionRef, where('resourceType', '==', 'J U Seekubadu - Binocular Vision')));
     const totalPages = Math.ceil(countSnapshot.data().count / pageSize);
     setTotalPages(totalPages);

   } catch (error) {
     console.error("Error fetching articles:", error);
   }
 };

 // Handle pagination click
 const paginate = (page) => {
   setCurrentPage(page);
   fetchBinocularVision(page);
 };

 useEffect(() => {
    fetchBinocularVision(currentPage);
 }, [currentPage]);



 return (
   <div>
         <section className="hero">
     <div className="hero-image">
         <img src="/imgbook.png" alt="Books and Research" />
       </div>
       <div className="hero-content">
         <h1>Eye Care Digital Library</h1>
         <p>Your gateway to advanced research and resources in optometry and vision science.</p>
       </div>
   </section>
   
     <h3>J U Seekubadu - Binocular Vision Science</h3>
     <div className="articles-container">
       {binocularVision.map((BinocularVisionarticle) => (
         <div key={BinocularVisionarticle.id} className="article-item">
           {/* <img src={article.coverImageURL} alt={article.title} /> */}
           <h4>{BinocularVisionarticle.title}</h4>
           <p>
             {BinocularVisionarticle.author} | {BinocularVisionarticle.publication_year} | {BinocularVisionarticle.isbn} | {BinocularVisionarticle.description}
           </p>
           <a href={BinocularVisionarticle.pdfFileURL} target="_blank" rel="noopener noreferrer">Read Article</a>
         </div>
       ))}
     </div>

     {/* Pagination */}
     <div className="pagination-container">
       <button
         className="pagination-button"
         onClick={() => paginate(currentPage - 1)}
         disabled={currentPage === 1}
       >
         Previous
       </button>
       {Array.from({ length: totalPages }, (_, index) => (
         <button
           key={index + 1}
           className={`pagination-button ${currentPage === index + 1 ? 'active' : ''}`}
           onClick={() => paginate(index + 1)}
         >
           {index + 1}
         </button>
       ))}
       <button
         className="pagination-button"
         onClick={() => paginate(currentPage + 1)}
         disabled={currentPage === totalPages}
       >
         Next
       </button>
     </div>
   </div>
 );
}
export default Binocular_vision